import { injectable } from 'inversify';
import { unit_option_magic_item_category_full } from '@Api';
import { RatioAction, UnitOptionMagicItemCategory } from '@Models';

@injectable()
export class UnitOptionMagicItemCategoryMapper {
  public map(
    item: unit_option_magic_item_category_full,
  ): UnitOptionMagicItemCategory {
    return {
      id: item.id,
      name: item.name ?? '',
      max: item.max,
      is_multiple: item.is_multiple,
      ratio: item.ratio ?? 1,
      ratioAction: this.mapRatioAction(item.ratio_action),
      maxByModel: item.max_by_model ?? null,
      minByModel: item.min_by_model ?? 0,
    } satisfies UnitOptionMagicItemCategory as UnitOptionMagicItemCategory;
  }

  mapRatioAction(
    action: unit_option_magic_item_category_full.ratio_action,
  ): RatioAction {
    switch (action) {
      case unit_option_magic_item_category_full.ratio_action.DECREASING:
        return RatioAction.Decreasing;
    }
    return RatioAction.Multiplier;
  }
}
